var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcUnion = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E7424C",
  fillRule: "evenodd",
  d: "M15.563.418a1.428 1.428 0 1 1 2.019 2.02L11.019 9l6.563 6.563a1.428 1.428 0 1 1-2.02 2.019L9 11.019l-6.563 6.563a1.428 1.428 0 0 1-2.019-2.02L6.981 9 .418 2.437A1.428 1.428 0 0 1 2.438.418L9 6.981z",
  clipRule: "evenodd"
})));
export default SvgIcUnion;